import { useQuery } from '@tanstack/react-query'

import { getPaymentRequestsBankAccountsList } from '@src/api'
import { DefaultApiGetPaymentRequestsBankAccountsListRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchPaymentRequestsBankAccountsList = (
  params: DefaultApiGetPaymentRequestsBankAccountsListRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getPaymentRequestsBankAccountsList(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_PAYMENT_REQUESTS_BANK_ACCOUNTS_LIST,
      params.organizationId,
    ],
  })
}
